import { useEffect, useRef, useState } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useNavigate
} from "react-router-dom";
import { useSelector } from 'react-redux';
import MTable from '../../Components/MTable/MTable';
import { deleteSOHeader, getSO, getClosedSO, verifyPayment, syncSOHeader } from '../../Service/SalesService';
import Swal from 'sweetalert2';
import Overlay from '../../Components/Overlay';
import moment from 'moment';
import 'moment/locale/id';
import { updateSO } from '../../Service/SalesService';

const SalesOrder = () => {
    let { userInfo } = useSelector(state => state.auth);
    moment.locale('id');
    const navigate = useNavigate();
    const tableSO = useRef();
    const [state, setState] = useState({ processing: false });
    const onAddData = () => {
        navigate("/salesorder/create");
    }

    const onEdit = item => () => {
        navigate("/salesorder/edit/" + item.id);
    };

    const onRemove = item => () => {
        Swal.fire(
            {
                icon: 'question',
                title: 'Are you sure?',
                text: 'Deleted Sales can not be restored!',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
            }
        ).then(({ isConfirmed }) => {
            if (isConfirmed) {
                setState({ processing: true })
                deleteSOHeader(item.id).then(res => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: `Delete Sales Order success!`
                    }).then(res => {
                        tableSO.current.refresh();

                    });
                }).catch(({ response }) => {
                    const { message } = response?.data;
                    Swal.fire({
                        icon: 'error',
                        title: `Delete Sales Order error!`,
                        text: message
                    });
                }).finally(() => {
                    setState({ processing: false })
                })
            }
        })
    };

    const handleSync = (data) => {
        setState({ processing: true })
        syncSOHeader(data.id).then(res => {
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: `Sync SO success!`
            }).then(res => {
                tableSO.current.refresh();

            });
        }).catch(({ response }) => {
            const { message } = response?.data;
            Swal.fire({
                icon: 'error',
                title: `Sync Sales Order error!`,
                text: message
            });
        }).finally(() => {
            setState({ processing: false })
        })
    }
    const columns = [
        { id: 1, title: 'Order Number', field: 'DocNumSO', sortable: true },
        { id: 2, title: 'Doc Number', field: 'DocNum', sortable: true },
        { id: 3, title: 'Customer', field: 'CardName', sortable: true },
        {
            id: 4, title: 'Created Date', field: 'DocDueDate', sortable: true, filter_text: "Please type in this format: 'YYYY-MM-DD HH.MM.SS', example: 2023-03-01 06.30.23.\n You can also exclude the hour, minute, seconds, date, month or year. Example : 2023-03 and 2023-04-01 16.04",
            render: data => {
                return moment(data.created_date).format('ll LTS')
            }
        },
        {
            id: 5,
            title: 'Status',
            field: 'Status',
            sortable: true,
            clickable: false,
            render: data => {
                var text = "";
                if (data.Status == 'Reject') {
                    text = <span className="badge bg-red me-2">REJECT</span>;
                } else if (data.Status == 'Paid') {
                    text = <span className="badge bg-paid me-2">PAID</span>;
                } else if (data.Status == 'Closed' && data.payment_verified === null) {
                    text = <span className="badge bg-close me-2">CLOSED</span>;
                } else if (data.Status == 'Open') {
                    text = <span className="badge bg-cyan me-2">OPEN</span>;
                } else if (data.Status == 'Pending') {
                    text = <span className="badge bg-teal me-2">PENDING</span>;
                } else if (data.Status == 'Sync') {
                    text = <span className="badge bg-teal me-2">SYNC</span>;
                } else if (data.Status == 'NotSync') {
                    text = <span className="badge bg-red me-2">NOTSYNC</span>;
                } else if (data.Status === "Cancelled") {
                    text = <span className="badge bg-red me-2">CANCELLED</span>;
                } else if (data.payment_verified === true) {
                    text = <span className="badge bg-green me-2">VERIFIED</span>;
                } else if (data.payment_verified === false) {
                    text = <span className="badge bg-red me-2" style={{ fontSize: "12px" }}>NOT VERIFIED</span>;
                }
                return text;
            },
        },
        {
            id: 6,
            title: 'Action',
            render: item => {
                return (
                    <div>
                        <a
                            onClick={onEdit(item)}
                            style={{
                                cursor: 'pointer',
                                color: 'green',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-edit" />
                            <span style={{ marginLeft: 10 }}>Edit</span>
                        </a>
                        {item.Status == 'Sync' && (
                            <a
                                onClick={() => handleSync(item)}
                                style={{
                                    cursor: 'pointer',
                                    color: 'orange',
                                    display: 'inline-block',
                                    marginRight: 20
                                }}
                            >
                                <i className="fas fa-sync" />
                                <span style={{ marginLeft: 10 }}>Sync</span>
                            </a>
                        )}
                        {((item.DocNumSO && item.DocNumSO.substring(0, 3) == 'TMP') || item.Status == 'Sync') &&
                            <a
                                onClick={onRemove(item)}
                                style={{
                                    cursor: 'pointer',
                                    color: 'maroon',
                                    display: 'inline-block',
                                    marginRight: 20
                                }}
                            >
                                <i className="fas fa-trash" />
                                <span style={{ marginLeft: 10 }}>Delete</span>
                            </a>
                        }

                    </div>
                );
            },
        },
    ];

    const verificator_columns = [
        { id: 1, title: 'Order Number', field: 'DocNumSO', sortable: true },
        { id: 2, title: 'Doc Number', field: 'DocNum', sortable: true },
        { id: 3, title: 'Customer', field: 'CardName', sortable: true },
        {
            id: 4, title: 'Created Date', field: 'created_date', sortable: true, filter_text: "Please type in this format: 'YYYY-MM-DD HH.MM.SS', example: 2023-03-01 06.30.23.\n You can also exclude the hour, minute, seconds, date, month or year. Example : 2023-03 and 2023-04-01 16.04",
            render: data => {
                return moment(data.created_date).format('ll LTS')
            }
        },
        {
            id: 9, title: 'Created By', field: 'created_by_name', sortable: true
        },
        {
            id: 10, title: 'BPL Name', field: 'BPLName', sortable: true
        },
        /*{
            id: 98,
            title: 'Order Status',
            field: 'Status',
            filter_text: "Please type 'Closed', 'Cancelled' (exact wording)",
            sortable: true,
            clickable: false,
            render: data => {
                var text = "";
                if (data.Status === "Closed") {
                    text = <span className="badge bg-paid me-2">Closed</span>;
                } else if (data.Status === "Cancelled") {
                    text = <span className="badge bg-red me-2">Cancelled</span>;
                } else {
                    text = <span className="badge bg-teal me-2">In Progress</span>;
                } 
                return text;
            },
        },
        {
            id: 99,
            title: 'Payment Status',
            field: 'payment_verified',
            filter_text: "Please type 'Verified', 'Not Verified', 'Waiting' (exact wording)",
            sortable: true,
            clickable: false,
            render: data => {
                var text = "";
                if (data.payment_verified === true && data.Status === "Closed") {
                    text = <span className="badge bg-paid me-2">Verified</span>;
                } else if (data.payment_verified === false && data.Status === "Closed") {
                    text = <span className="badge bg-red me-2">Not Verified</span>;
                } else if (data.payment_verified === null && data.Status === "Closed") {
                    text = <span className="badge bg-teal me-2">Waiting</span>;
                } else if (data.Status === "Cancelled") {
                    text = <span className="badge bg-red me-2">Cancelled</span>;
                }
                return text;
            },
        },*/
        {
            id: 99,
            title: 'Status',
            field: 'calculated_status',
            filter_text: "Please type 'Verified', 'Not Verified', 'Waiting' (exact wording)",
            sortable: false,
            clickable: false,
            render: data => {
                var text = "";
                if (data.payment_verified === true && data.Status === "Closed") {
                    text = <span className="badge bg-paid me-2">Verified</span>;
                } else if (data.payment_verified === false && data.Status === "Closed") {
                    text = <span className="badge bg-red me-2">Rejected</span>;
                } else if (data.payment_verified === null && data.Status === "Closed") {
                    if (data.calculated_status === "waiting IPG payment") {
                        text = <span className="badge bg-teal me-2" style={{ width: "140px" }}>Waiting IPG Payment</span>;
                    } else {
                        text = <span className="badge bg-teal me-2" style={{ width: "140px" }}>Waiting Verification</span>;
                    }

                } else if (data.Status === "Cancelled") {
                    text = <span className="badge bg-red me-2">Cancelled</span>;
                }
                return text;
            },
        },
        {
            id: 6, title: 'Verification Date', field: 'payment_verification_date', sortable: true, filter_text: "Please type in this format: 'YYYY-MM-DD HH.MM.SS', example: 2023-03-01 06.30.23.\n You can also exclude the hour, minute, seconds, date, month or year. Example : 2023-03 and 2023-04-01 16.04",
            render: data => {
                if (data.payment_verification_date)
                    return moment(data.payment_verification_date).format('ll LTS')
            }
        },
        { id: 7, title: 'Verified By', field: 'payment_verified_by', sortable: true },
        {
            id: 8,
            title: 'Action',
            render: item => {
                if (!item.payment_verification_date && item.calculated_status !== 'waiting IPG payment')
                    return (
                        <>
                            <div style={{ width: 170 }}>
                                <a
                                    onClick={onEdit(item)}
                                    style={{
                                        cursor: 'pointer',
                                        color: 'green',
                                        display: 'inline-block',
                                        marginRight: 20
                                    }}
                                >
                                    <i className="fas fa-check" />
                                    <span style={{ marginLeft: 10 }}>Verify</span>
                                </a>
                            </div>
                        </>
                    );
                else if (item.payment_verified === false && item.payment_verification_date && item.Status !== "Cancelled")
                    return (
                        <>
                            <div style={{ width: 170 }}>
                                <a
                                    onClick={onEdit(item)}
                                    style={{
                                        cursor: 'pointer',
                                        color: 'black',
                                        display: 'inline-block',
                                        marginRight: 20
                                    }}
                                >
                                    <i className="fas fa-eye" />
                                    <span style={{ marginLeft: 10 }}>View</span>
                                </a>
                            </div>
                            <div style={{ width: 170 }}>

                                <a
                                    onClick={() => {
                                        const swalWithBootstrapButtons = Swal.mixin({
                                            customClass: {
                                                confirmButton: 'btn btn-modena',
                                                cancelButton: 'btn btn-readonly mr-3'
                                            },
                                            buttonsStyling: false
                                        })
                                        swalWithBootstrapButtons.fire(
                                            {
                                                title: 'Confirmation',
                                                text: 'Are you sure you want to cancel this order ?',
                                                confirmButtonColor: '#3085d6',
                                                showCancelButton: true,
                                                confirmButtonText: 'Yes',
                                                reverseButtons: true
                                            }
                                        ).then(({ isConfirmed }) => {
                                            if (isConfirmed) {
                                                updateSO(item.id, { Status: "Cancelled" }).then(res => {
                                                    if (res.status == 200) {
                                                        onCancelPayment(item.id).then(res => {
                                                            if (res.status == 200 && res.data == "SO is being cancelled") {
                                                                Swal.fire(
                                                                    {
                                                                        icon: 'success',
                                                                        title: 'Cancel SO Success',
                                                                    }
                                                                ).then(_ => {
                                                                    tableSO.current.refresh();
                                                                    return;
                                                                });
                                                            } else {
                                                                //this means belum masuk SAP. harus di-resend
                                                                Swal.fire(
                                                                    {
                                                                        icon: 'success',
                                                                        title: 'Cancel SO Success, Pending Backend Verification',
                                                                    }
                                                                ).then(() => {
                                                                    tableSO.current.refresh();
                                                                    return;
                                                                });

                                                                return;
                                                            }
                                                        })
                                                    } else {
                                                        Swal.fire(
                                                            {
                                                                icon: 'error',
                                                                title: 'Cancel SO Failed',
                                                            }
                                                        );
                                                    }
                                                }).catch(err => {
                                                    Swal.fire(
                                                        {
                                                            icon: 'success',
                                                            title: 'Cancel SO Failed',
                                                        }
                                                    );
                                                })
                                            }
                                        })

                                    }}
                                    style={{
                                        cursor: 'pointer',
                                        color: 'red',
                                        display: 'inline-block',
                                        marginRight: 20
                                    }}
                                >
                                    <i className="fa fa-times" />
                                    <span style={{ marginLeft: 10 }}>Cancel</span>
                                </a>
                            </div>
                        </>
                    )
                else {
                    return (
                        <div style={{ width: 170 }}>
                            <a
                                onClick={onEdit(item)}
                                style={{
                                    cursor: 'pointer',
                                    color: 'black',
                                    display: 'inline-block',
                                    marginRight: 20
                                }}
                            >
                                <i className="fas fa-eye" />
                                <span style={{ marginLeft: 10 }}>View</span>
                            </a>
                        </div>
                    );
                }
            },
        },
    ];

    const onCancelPayment = async (id_so) => {
        const res = await verifyPayment(id_so)
        return res;
        /*if(res.status == 200){
            Swal.fire({
                icon: 'success',
                title: "Payment Verification Done!",
                text: status == "R"? "Payment succesfully verified. Your purchase order is being processed": "Payment succesfully rejected"
            }).then(() => setState({...state, refresh: true}));
        } else if(res.message == "SO is being cancelled") {
            Swal.fire({
                icon: 'success',
                title: "Success!",
                text: "Sales Order has been cancelled"
            }).then(() => setState({...state, refresh: true}));
        }else {
            Swal.fire({
                icon: 'success',
                title: "Payment Verification failed!",
                text: "Please re-check your data or contact support!"
            });
        }*/
    }

    const showAddButton = (role_name) => {
        if (role_name == "SO Payment Verificator") return false;
        return true;
    }

    const tableGetData = (role_name) => {
        return getSO;
    }

    const genTableColumns = (role_name) => {
        if (role_name == "SO Payment Verificator" || role_name == "SO Payment Verificator - MHC Dealer") {
            return verificator_columns;
        }
        return columns;
    }

    const propsTable = { columns: genTableColumns(userInfo.role_name), getData: tableGetData(userInfo.role_name), showIndex: true, showAddButton: showAddButton(userInfo.role_name), onAddData, order: 'created_date', direction: 'desc' };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">Sales Order List</h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-body">
                            <Overlay display={state.processing} />
                            <div className='table-responsive'>
                                <MTable {...propsTable} ref={tableSO} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

};

export default SalesOrder;